import React, { useState, useEffect } from 'react';
import { Button, Table, Form, Modal, Card } from 'react-bootstrap';
import EnlargableTextbox from 'components/common/EnlargableTextbox';
import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
import { useSelector, useDispatch } from 'react-redux';
import { formChangedAction } from 'actions';
import { toast } from 'react-toastify';
import {
  getLitigationTypeDetailListAPI,
  litigationTypeDetailAction
} from 'actions/LitigationTypesDetail/litigationTypesDetailAction';

const LitigationTypeMasterDetailsData = () => {
  const dispatch = useDispatch();
  const [rowData, setRowData] = useState([]);
  const [formHasError, setFormError] = useState(false);
  var responseLitigationCode = localStorage.getItem(
    'EncryptedResponseLitigationTypeMasterCode'
  );
  let token = localStorage.getItem('Token') || sessionStorage.getItem('Token');
  const headers = {
    Authorization: `Bearer ${JSON.parse(token).value}`
  };

  const columnsArray = [
    'S.No',
    'Litigation Detail Code',
    'Litigation Types Detail',
    'Status'
  ];

  const emptyRow = {
    id: rowData.length + 1,
    encryptedLitigationTypeDetailCode: localStorage.getItem("EncryptedresponseLitigationTypCode"),
    subLitigationCode: '',
    litigationTypeDetailName: '',
    activeStatus: 'Active',
    addUser: localStorage.getItem('LoginUserName')
  };

  const litigationTypesDetailReducer = useSelector(
    state => state.rootReducer.litigationTypesDetailReducer
  );
  const litigationTypesDetailData =
    litigationTypesDetailReducer.litigationTypeDetail;

  const formChangedReducer = useSelector(
    state => state.rootReducer.formChangedReducer
  );
  var formChangedData = formChangedReducer.formChanged;

  const litigationTypeDetailErrorReducer = useSelector(
    state => state.rootReducer.litigationTypeDetailErrorReducer
  );
  const litigationTypeDetailError =
    litigationTypeDetailErrorReducer.litigationTypeDetailError;

  useEffect(() => {
    if (litigationTypesDetailReducer.litigationTypeDetail.length > 0) {
      setRowData(litigationTypesDetailData);
    }
  }, [litigationTypesDetailData, litigationTypesDetailReducer]);

  useEffect(() => {

    if (responseLitigationCode) {
      getLitigationTypeDetailList(responseLitigationCode);
    }
  }, [responseLitigationCode]);

  const getLitigationTypeDetailList = async (litigationCode, index) => {
    const data = {
      LitigationCode: litigationCode
    };
    await dispatch(
      getLitigationTypeDetailListAPI(
        data,
        res => {
          if (res && res.length > 0) {
            dispatch(
              litigationTypeDetailAction(res)
            );
          } else {
            dispatch(litigationTypeDetailAction([]));
          }
        },
        err => {
          console.log("something went wrong")
          dispatch(litigationTypeDetailAction([]))
        },
        headers
      )
    );
  };

  const validateLitigationTypeDetailsForm = () => {
    let isValid = true;

    if (litigationTypesDetailData && litigationTypesDetailData.length > 0) {
      const seenCombination = {};
      litigationTypesDetailData.forEach((row, index) => {
        if (!row.litigationTypeDetailName) {
          isValid = false;
          setFormError(true);
        } 
      });
    }

    if (isValid) {
      setFormError(false);
    }

    return isValid;
  };

  const handleAddRow = () => {
    let formValid = validateLitigationTypeDetailsForm();
    if (formValid) {
      litigationTypesDetailData.unshift(emptyRow);
      dispatch(litigationTypeDetailAction(litigationTypesDetailData));
    }
    checkDuplicateStateName(litigationTypesDetailData.litigationTypeDetailName)
  };

  const handleFieldChange = (e, index) => {
    const { name, value } = e.target;
    var litigationTypeDetailData = [...rowData];
    litigationTypeDetailData[index][name] = value;
    litigationTypeDetailData = Object.keys(rowData).map(key => {
      return rowData[key];
    });
    dispatch(litigationTypeDetailAction(litigationTypeDetailData));
    if (litigationTypeDetailData[index].subLitigationCode) {
      dispatch(
        formChangedAction({
          ...formChangedData,
          LitigationTypeMasterDetailUpdate: true
        })
      );
    } else {
      dispatch(
        formChangedAction({
          ...formChangedData,
          litigationTypeMasterDetailAdd: true
        })
      );
    }
  };

const checkDuplicateStateName = (litigationTypeDetailName, index) => {
  if (!litigationTypeDetailName) return;

  const isDuplicate = rowData.some(
    (item, i) =>
    item.litigationTypeDetailName.toLowerCase() === litigationTypeDetailName.toLowerCase() && i !== index
  );

  if (isDuplicate) {
    toast.error(`The litigation detail name "${litigationTypeDetailName}" is already in use!`, {
    theme: 'colored',
    autoClose: 10000
    });
    dispatch(
      formChangedAction({
        ...formChangedData,
        litigationTypeMasterDetailAdd: false,
        LitigationTypeMasterDetailUpdate: false
      })
    );
  }else{
    dispatch(
      formChangedAction({
        ...formChangedData,
        litigationTypeMasterDetailAdd: true,
        LitigationTypeMasterDetailUpdate: true
      })
    );
  }
  };

  return (
    <>
      <Card className=" h-100 state-master-card">
        <FalconCardHeader
          title="Litigation Details"
          titleTag="h6"
          className="py-2"
          light
          endEl={
            <Flex>
              <div>
                <Button
                  variant="primary"
                  size="sm"
                  className="btn-reveal"
                  type="button"
                  onClick={handleAddRow}
                >
                  Add Litigation Details
                </Button>
              </div>
            </Flex>
          }
        />
        {litigationTypesDetailData && litigationTypesDetailData.length > 0 && (
          <Card.Body className="position-relative pb-0 p3px mr-table-card ">
            <Form
              noValidate
              validated={
                formHasError ||
                (litigationTypeDetailError.litigationTypeDetailErr &&
                  litigationTypeDetailError.litigationTypeDetailErr.nameEmpty)
              }
              className=""
              id="AddLitigationTypeDetailsForm"
            >
              <div className="table-responsive">
                <Table
                  striped
                  bordered
                  responsive
                  id="TableList"
                  className="no-pb text-nowrap tab-page-table"
                >
                  <thead className="custom-bg-200">
                    <tr>
                      {columnsArray.map((column, index) => (
                        <th className="text-left" key={index}>
                          {column}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody id="tbody" className="">
                    {rowData.map((litigationTypesDetail, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td key={index}>
                          <EnlargableTextbox
                            name="subLitigationCode"
                            placeholder="Litigation Detail Code"
                            value={litigationTypesDetail.subLitigationCode}
                            maxLength={5}
                            disabled
                            className="form-control"
                            required
                          />
                        </td>
                        <td key={index}>
                          <Form.Control
                            name="litigationTypeDetailName"
                            placeholder="Litigation Types Detail"
                            onChange={e => handleFieldChange(e, index)}
                            onBlur={() => checkDuplicateStateName( litigationTypesDetail.litigationTypeDetailName, index)}
                            // onBlur={e => checkDuplicateLitigationTypeDetail(e.target.value, index)}
                            value={
                              litigationTypesDetail.litigationTypeDetailName
                            }
                            maxLength={50}
                            className="form-control"
                            required
                          />
                        </td>

                        <td key={index}>
                          <Form.Select
                            id="txtStatus"
                            col="1"
                            name="activeStatus"
                            value={litigationTypesDetail.activeStatus || "Active"}
                            onChange={e => handleFieldChange(e, index)}
                          >
                            <option value="Active">Active</option>
                            <option value="Suspended">Suspended</option>
                          </Form.Select>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Form>
          </Card.Body>
        )}
      </Card>
    </>
  );
};
export default LitigationTypeMasterDetailsData;